import { Tooltip, Button } from "@mui/material";
import React from "react";
import AddIcon from "@mui/icons-material/Add";
import { LoadingButton } from "@mui/lab";
import { validateFiles } from "src/utils/validate-files";

interface IApprovalAddFileProps {
  onAddFile: (files: FileList | null) => void;
  disabled?: boolean;
  isPending: boolean;
}

export const ApprovalAddFile: React.FC<IApprovalAddFileProps> = ({
  onAddFile,
  disabled,
  isPending,
}) => {
  const _handleAddFile = async (event: React.ChangeEvent<HTMLInputElement>) => {
    if (!event.target.files) return;

    const validFiles = validateFiles(event.target.files);
    if (!validFiles) return;

    onAddFile(validFiles);
  };

  return (
    <Tooltip title=".png, .jpg, .jpeg, .mp4, .pdf">
      <LoadingButton
        variant="outlined"
        color="primary"
        size="small"
        startIcon={<AddIcon />}
        component="span"
        style={{ position: "relative", overflow: "hidden" }}
        disabled={disabled}
        loading={isPending}
      >
        Arquivos
        <input
          accept="image/*, video/*, application/pdf"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            opacity: 0,
            cursor: "pointer",
          }}
          type="file"
          multiple
          onChange={_handleAddFile}
        />
      </LoadingButton>
    </Tooltip>
  );
};
